<template>
    <div class="layer-content">
        tests<br/>
        <button @click="close()">닫기</button>
    </div>
</template>

<script>
    export default {
        name: 'test_popup',
        props: ['index','param'],
        methods: {
            close: function(){
                this.$store.commit('closePopup',this.index);
            }
        }
    }
</script>

<style scoped>

</style>